var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComfort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_541_1106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.838623,
    width: 26.3226,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_541_1106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 21C12.4828 21 11.1895 20.5125 10.1201 19.5375C9.05079 18.5625 8.51611 17.3833 8.51611 16C8.51611 15.2 8.70805 14.4542 9.09192 13.7625C9.47579 13.0708 10.015 12.4833 10.7097 12V6C10.7097 5.16667 11.0296 4.45833 11.6693 3.875C12.3091 3.29167 13.086 3 14 3C14.914 3 15.6908 3.29167 16.3306 3.875C16.9704 4.45833 17.2903 5.16667 17.2903 6V12C17.9849 12.4833 18.5242 13.0708 18.9081 13.7625C19.2919 14.4542 19.4839 15.2 19.4839 16C19.4839 17.3833 18.9492 18.5625 17.8798 19.5375C16.8105 20.5125 15.5172 21 14 21ZM14 19C14.914 19 15.6908 18.7083 16.3306 18.125C16.9704 17.5417 17.2903 16.8333 17.2903 16C17.2903 15.5167 17.1761 15.0667 16.9476 14.65C16.7191 14.2333 16.3946 13.8833 15.9742 13.6L15.0968 13V6C15.0968 5.71667 14.9917 5.47917 14.7814 5.2875C14.5712 5.09583 14.3107 5 14 5C13.6892 5 13.4287 5.09583 13.2185 5.2875C13.0083 5.47917 12.9032 5.71667 12.9032 6V13L12.0258 13.6C11.6054 13.8833 11.2809 14.2333 11.0524 14.65C10.8239 15.0667 10.7097 15.5167 10.7097 16C10.7097 16.8333 11.0296 17.5417 11.6693 18.125C12.3091 18.7083 13.086 19 14 19Z",
    fill: "#1793D1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfort);
export default __webpack_public_path__ + "static/media/comfort.32b318d3e1f395dec9993f88ad3ae6ca.svg";
export { ForwardRef as ReactComponent };